<script setup lang="ts">
import { computed, ref } from 'vue';
import {
  Contexts,
  getContainer,
  NamedBindings,
  TranslationService,
} from '@dandelion/core';
import userIconUrl from '../assets/icon/32/user.svg';
import { Users } from '../enum/Users';
import { UserService } from '../services/UserService';

const userService = getContainer(Contexts.SHARED).get(
  NamedBindings.UserService
) as UserService;
const ts = getContainer(Contexts.SHARED).get(
  NamedBindings.TranslationService
) as TranslationService;
const isShowing = ref(false);
const isLogged = userService.getIsLogged();
const currentUser = userService.getCurrentUser();

const centreLabel = computed(() => currentUser?.value?.centre || '');

function goToAccountManage() {
  window.location.href = `${import.meta.env.VITE_APP_AUTH_BASE_URL}Identity/Account/Manage`;
}

const displayRolesMap = new Map()
  .set(Users.SUPPORT_ADMIN, 'Amministratore supporto')
  .set(Users.ADMIN, 'Amministratore')
  .set(Users.READER, 'Lettore')
  .set(Users.WRITER, 'Compilatore');

document.addEventListener('click', () => (isShowing.value = false));
</script>

<template>
  <section id="user-section">
    <button type="button" v-html="ts.t('Log Out')" v-if="isLogged" @click="userService.logOut()"></button>
    <button type="button" class="secondary-button" v-html="ts.t('Log In')" v-else
      @click.stop="userService.goToLogIn()"></button>
    <div id="user-info" v-if="isLogged"><div class="tooltip">
      <img alt="Cambio Password"  id="user-img" :src="userIconUrl" @click="goToAccountManage()" />
      
  <span class="tooltiptext">Gestione Utente</span>
</div> 
      <dl id="user-name" @click.stop="isShowing = true">
        <dd id="name">{{ currentUser?.username ?? '' }}</dd>
        <dd id="role">{{ displayRolesMap.get(currentUser?.role) ?? '' }}</dd>
        <dd id="centre">{{ centreLabel ?? '' }}</dd>
      </dl>
    </div>
  </section>
</template>

<style scoped>
#user-section {
  display: flex;
}

#user-info {
  display: flex;
  align-items: center;
  color: white;
}
#user-img{
  cursor: pointer;
}
#user-info #user-name {
  display: flex;
  line-height: normal;
  flex-direction: column;
  padding: 0 0.5rem;
  border-left: 0.15rem solid lightgrey;
  gap: 1px;
}

#user-info #user-name dd {
  line-height: 1.2;
}
/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* Add dots under the hoverable text */
  cursor: pointer;

}

/* Tooltip text */
.tooltiptext {
  visibility: hidden; /* Hidden by default */
  width: 130px;
  background-color: black;
  color: #ffffff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  font-size: smaller;
  z-index: 1; /* Ensure tooltip is displayed above content */
}

/* Show the tooltip text on hover */
.tooltip:hover .tooltiptext {
  visibility: visible;
}
#user-info img {
  height: 2em;
  margin: 0 0.5rem 0 0.75rem;
}

#user-info #name,
#user-info #centre,
#user-info #role {
  font-size: 0.8rem;
}

#user-info #name,
#user-info #centre {
  font-weight: 700;
}
</style>
